<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="cont" title="Contents">
<p class="h2f"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">CONTENTS</span></p>
<p class="tocf0" id="ack"><a href="#/text/9780253044792_Acknowledgments"><i>Acknowledgments</i></a></p>
<p class="tocf" id="source"><a href="#/text/9780253044792_Sources"><i>A Note on Sources</i></a></p>
<p class="tocf" id="abbrev"><a href="#/text/9780253044792_Abbreviations"><i>List of Abbreviations and Short Names</i></a></p>
<p class="tocf1" id="int"><a href="#/text/9780253044792_Introduction">Introduction</a></p>
<p class="tocc" id="ch1"><span href="#/text/9780253044792_Chapter_1" title="Link target outside of Sample">1<span class="spacec">Tensed Urban Visions: Making Bucharest into a Socialist Capital</span></span></p>
<p class="tocc" id="ch2"><span href="#/text/9780253044792_Chapter_2" title="Link target outside of Sample">2<span class="spacec">Matters of State: Archaeology, Materiality, and State Making</span></span></p>
<p class="tocc" id="ch3"><span href="#/text/9780253044792_Chapter_3" title="Link target outside of Sample">3<span class="spacec">Time-Traveling Houses and Histories Made Invisible</span></span></p>
<p class="tocc" id="ch4"><span href="#/text/9780253044792_Chapter_4" title="Link target outside of Sample">4<span class="spacec">Lipstick and Lined Pockets: Strategic Devaluation and Postsocialist Wealth</span></span></p>
<p class="tocc" id="ch5"><span href="#/text/9780253044792_Chapter_5" title="Link target outside of Sample">5<span class="spacec">Displacements: Property, Privatization, and Precarity in a Europeanizing City</span></span></p>
<p class="tocf" id="con"><span href="#/text/9780253044792_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="tocf1" id="bib"><span href="#/text/9780253044792_Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="tocf" id="ind"><span href="#/text/9780253044792_Index" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044792_Contents.vue?1d6e9a36